import './utils/domResilience';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store/store';
import App from './App';
import './styles/global.css';
import { HelmetProvider } from 'react-helmet-async';
import { AudioPlayerProvider } from './context/AudioPlayerProvider';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <HelmetProvider>
      <AudioPlayerProvider>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </AudioPlayerProvider>
    </HelmetProvider>
  </Provider>
);
